import React from 'react';

import { currency } from '../../config';
import { getDiscountTypeLabel } from '../../app/discount-logic';

const CartDiscount = ({ items = [], restaurantDetails = {} }) => {
  if (!items.reduce) {
    return null;
  }
  const itemsWithDiscount = items.filter(item => item.hasDiscount);
  if (!itemsWithDiscount.length) {
    return null;
  }
  const reducer = (dict, item) => {
    const label = getDiscountTypeLabel(item, restaurantDetails);
    dict[label] = item.discountAmount + (dict[label] || 0);
    return dict;
  };
  const discountsDict = itemsWithDiscount.reduce(reducer, {})
  return <>
    <div className="cart-discount-label">Naliczono rabaty: </div>
    {
      Object.entries(discountsDict).map(([text, amount]) => <div key={text} className="cart-discount-label">
        {text}: {amount} {currency}
      </div>)
    }
  </>
};

export default CartDiscount;
